export default __webpack_public_path__ + "static/media/My-profile.d229b6b7.svg";